export default __webpack_public_path__ + "static/media/card-back-hex-1.094ab263.png";